import React from 'react';
// Styles
import "./../../index.css";

import webdev from "../../assets/lottie/webdev.json";
import DisplayLottie from "../DisplayLottie/DisplayLottie";

import { skillsSection } from "../../projects";

const Services = () => {
  return (
      <section
          data-aos="zoom-in"
          className="services-container row"
          name="services"
          id="services"
      >
        <div className="services-wrapper">
          <div className="servicesPic">
            <DisplayLottie animationData={webdev}/>
          </div>
        </div>
        <h1 className="heading">Services I Provide</h1>
        <p className="subtitle">{skillsSection.subTitle}</p>
        <div className="skills-list">
          {
            skillsSection.skills.map(skill => {
              return (
                <div key={skill.heading} className="skill-item">
                  <span className="skill-heading">{skill.heading}</span>
                  <span className="skill-description">{skill.description}</span>
                </div>
              );
            })
          }
        </div>
      </section>
  );
};

export default Services;
